var createCheckboxStatesHashMap = function createCheckboxStatesHashMap(checkedValues, allValues) {
  var checkedValuesHashMap = {};
  checkedValues.forEach(function (value) {
    checkedValuesHashMap[value] = true;
  });
  var checkedStatesHashMap = {};
  allValues.forEach(function (value) {
    checkedStatesHashMap[value] = checkedValuesHashMap[value] || false;
  });
  return checkedStatesHashMap;
};
var createCheckedValuesArrayFromStates = function createCheckedValuesArrayFromStates(checkboxStates) {
  return Object.keys(checkboxStates).filter(function (checkboxValue) {
    return checkboxStates[checkboxValue];
  });
};

export { createCheckboxStatesHashMap, createCheckedValuesArrayFromStates };
